/*
 * @Description: 我的优惠券页面
 * @Author: maowy
 * @Date: 2020-10-10 14:33:31
 * @Last Modified by: yongyao
 * @Last Modified time: yyyy-08-Th 10:26:01
*/

import Vue from 'vue'
// import _ from 'lodash'
import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'
import { Loading } from 'vant'
import Footer from '@/components/footer/footer.vue'
import CouponInfo from '@/components/couponInfo/couponInfo.vue'
import {
    getCouponListByService,
    getCouponListByPackage
} from '@/models/userCoupon.js'
import { setLocalConfig, getLocalConfig } from '../../utils/session'

Vue.use(Loading)

export default {
    inject: ['showLoading', 'hideLoading'],
    name: viewName.couponDetail,
    components: {
        'fc-footer': Footer,
        CouponInfo
    },
    data () {
        return {
            couponList: [],
            params: {       // 请求参数
                page: 1,
                pageSize: 10,
            },
            loadData: false,
            hasData: true,
            checked: true,
            selectCoupon: ''
        }
    },
    computed: {
        ...mapState({
        }),
    },
    watch: {
    },
    created () {
        this.setBasic()
        this.selectCoupon = getLocalConfig('SELECT_COUPON')
        document.body.scrollIntoView()
        this.getListData()
        window.addEventListener('scroll', this.scrollLoad)
    },
    activated () {
    },
    async mounted () {

    },
    methods: {
        ...mapActions([
            'setAppClass'
        ]),
        setBasic () {
            this.setAppClass({
                isAppend: true,
                className: 'bgGreyColor'
            })
            this.$emit('setHeader', {
                title: '可用优惠券',
                showHeader: true,
                showLeft: true
            })
        },
        /**
         * from字段代表着从营销活动确认订单页面进来
         * 请求套餐包优惠券列表数据，反之请求服务优惠券列表数据
         */
        getListData () {
            this.$route.query.from ? this.getPackageCouponList() : this.getServiceCouponList()
        },
        // 获取套餐包优惠券列表数据
        getPackageCouponList () {
            let { sstore_id, package_id } = this.$route.query
            // let services = JSON.stringify(getLocalConfig('USE_COUPON_SERVICE'))
            let {
                page,
                pageSize
            } = this.params
            this.fetchData = false
            this.showLoading()
            getCouponListByPackage({
                sstore_id,
                package_id,
                page,
                pageSize,
            }).then(res => {
                this.hideLoading()
                let list = res
                list.forEach(item => {
                    item.is_select = false
                    if (this.selectCoupon.coupon_id === item.coupon_id && this.selectCoupon.user_coupon_id === item.user_coupon_id) {
                        item.is_select = true
                    }
                })
                this.couponList = this.couponList.concat(list)
                if (list.length && list.length === this.params.pageSize) {
                    this.params.page++
                    this.loadData = true
                } else {
                    this.loadData = false
                    this.hasData = false
                }
                this.fetchData = true
            }).catch(err => {
                this.hideLoading()
                console.log(err)
            })
        },
        /**
         * 请求数据
         */
        getServiceCouponList () {
            let { coupon_id, sstore_id } = this.$route.query
            let services = JSON.stringify(getLocalConfig('USE_COUPON_SERVICE'))
            let {
                page,
                pageSize
            } = this.params
            this.fetchData = false
            this.showLoading()
            getCouponListByService({
                coupon_id,
                sstore_id,
                services,
                page,
                pageSize,
            }).then(res => {
                this.hideLoading()
                let list = res
                list.forEach(item => {
                    item.is_select = false
                    if (this.selectCoupon.coupon_id === item.coupon_id && this.selectCoupon.user_coupon_id === item.user_coupon_id) {
                        item.is_select = true
                    }
                })
                this.couponList = this.couponList.concat(list)
                if (list.length && list.length === this.params.pageSize) {
                    this.params.page++
                    this.loadData = true
                } else {
                    this.loadData = false
                    this.hasData = false
                }
                this.fetchData = true
            }).catch(err => {
                this.hideLoading()
                console.log(err)
            })
        },
        scrollLoad () {
            // 真实内容的高度
            var pageHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight)
            // 视窗的高度
            var viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0
            // 隐藏的高度
            var scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
            if (pageHeight - viewportHeight - scrollHeight < 50 && this.loadData && this.fetchData) { // 如果满足触发条件，执行
                this.getListData()
            }
        },
        // 选择优惠券
        checkboxChange (coupon) {
            setLocalConfig('a', coupon.user_coupon_id)
            if (coupon.is_select) {
                setLocalConfig('SELECT_COUPON', '')
            } else {
                setLocalConfig('SELECT_COUPON', coupon)
            }
            let couponList = this.couponList
            couponList.forEach((item) => {
                item.is_select = false
                if (coupon.coupon_id === item.coupon_id && coupon.user_coupon_id === item.user_coupon_id) {
                    item.is_select = coupon.is_select
                }
            })
            this.couponList = couponList
            this.$router.go(-1)
        }
    },
    destroyed () {
        window.removeEventListener('scroll', this.scrollLoad)
    },
}
